module.exports = __webpack_public_path__ + "static/media/dark_icn_map_pin_bus_ls_selected.d031b4b7.svg";